import React, { useEffect, useState } from "react";
import axios from "../utils/axiosConfig";
import { formatReportDate } from "../utils/reportDate";

const FollowupModal = ({ show, dealId, onClose }) => {

  const [followups, setFollowups] = useState([]);
  const [remarks, setRemarks] = useState("");

  useEffect(() => {

    if (show && dealId) {
      fetchFollowups();
    }

  }, [show, dealId]);


  const fetchFollowups = async () => {

    try {

      const res = await axios.get(`/followups/${dealId}`);
      setFollowups(res.data);

    } catch (err) {

      console.error(err);

    }

  };


  const saveFollowup = async () => {

    if (!remarks.trim()) {
      alert("Enter remarks");
      return;
    }

    try {

      await axios.post("/followups", {
        dealId,
        remarks: remarks.trim()
      });

      setRemarks("");
      fetchFollowups();

    } catch (err) {

      alert(err.response?.data?.message || "Error saving followup");

    }

  };


  if (!show) return null;


  return (

    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>

      <div className="modal-dialog modal-lg">

        <div className="modal-content">

          <div className="modal-header">
            <h5>FollowUp Details : {dealId}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">


            {/* FOLLOWUP LIST */}

            <div className="card mb-3">

              <div className="card-header">
                Followup List
              </div>

              <div className="card-body" style={{ height: 200, overflowY: "auto" }}>

                {followups.length === 0 ? (

                  <div className="text-center text-muted">
                    No followup has been done so far.
                  </div>

                ) : (

                  <table className="table table-sm">

                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Remarks</th>
                        <th>User</th>
                      </tr>
                    </thead>

                    <tbody>

                      {followups.map(f => (

                        <tr key={f.FollowupID}>
                          <td>{f.FollowupDate?.split("T")[0]}</td>
                          <td>{f.Remarks}</td>
                          <td>{f.CreatedBy}</td>
                        </tr>

                      ))}

                    </tbody>

                  </table>

                )}

              </div>

            </div>


            {/* ADD FOLLOWUP */}

            <div className="card">

              <div className="card-header">
                Add Followup
              </div>

              <div className="card-body">

                <div className="row mb-2">

                  <div className="col-md-6">
                    Date : {formatReportDate(new Date())}
                  </div>

                  <div className="col-md-6 text-end">
                    User : Shipping
                  </div>

                </div>

                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter remarks..."
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />

                <div className="mt-2">

                  <button
                    type="button"
                    className="btn btn-success btn-sm me-2"
                    onClick={saveFollowup}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary btn-sm"
                    onClick={onClose}
                  >
                    Close
                  </button>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default FollowupModal;
